/* eslint-disable import/prefer-default-export */
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {  
    left: -80%;
  }  
  5%, 95% {  
    left: 50%;
    transform: translateX(-50%);
  }  
  to {
    left: -80%;
  }
`;

export const Wrapper = styled.span`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 32px;
  cursor: pointer;
  z-index: 99;
  text-decoration: none;
  color: ${({ theme }) => theme.base.white};
  line-height: 1;
  font-family: Exo BNNVARA, Exo, Verdana, sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  white-space: nowrap;
  width: max-content;
  background-color: #cd0000;
  animation: ${slideIn} 24s forwards;
  margin: 0;
} 
`;
